/*
 * $Id:: request.js 2021/01/15 04:15 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { getLoginUrl } from '../../providers';
import ApiError from '../ApiError';

const apiPrefix = '/UserArea/api/v1';

const CSRF_HEADER_NAME = 'X-CSRF-HEADER-NAME';
let csrfHeaderName = null;
let csrfToken = null;

const checkCsrfHeaders = (response) => {
    let auxCsrfHeaderName = response.headers.get(CSRF_HEADER_NAME);
    if (auxCsrfHeaderName) {
        let auxCsrfToken = response.headers.get(auxCsrfHeaderName);
        if (auxCsrfToken) {
            csrfToken = auxCsrfToken;
            csrfHeaderName = auxCsrfHeaderName;
        }
    }
};

const apiParams = (body, type = 'POST', additionalHeaders = {}, includeCsrf = false) => {
    const headers = {
        'Content-Type': 'application/json',
        ...additionalHeaders,
    };

    if (csrfToken && includeCsrf) {
        headers[csrfHeaderName] = csrfToken;
    }
    const isApplicationJson = headers['Content-Type'] === 'application/json';
    return {
        method: type, // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache',
        credentials: 'same-origin',
        headers,
        body: isApplicationJson ? JSON.stringify(body) : body,
    };
};

const sendRequest = ({ url, method, body, prefix = null, headers = {}, noResponse = false, doNotRedirect = false, returnJSON = true }) => {
    let code;
    const includeCsrf = !prefix || prefix === apiPrefix;
    return fetch(`${prefix || apiPrefix}${url}`, apiParams(body, method, headers, includeCsrf))
        .then((res) => {
            code = res.status;

            if (includeCsrf) {
                checkCsrfHeaders(res);
            }
            if (code === 401 && !doNotRedirect) {
                // Intercept call to empty cached user, if any, and redirect to login page.
                // window.location.replace(`${apiHost}:${apiPort}`);
                const loginUrl = getLoginUrl();
                window.location.replace(loginUrl);
            }
            if (code === 401 && res.headers.get('message') === 'SSO error occured') {
                window.location.replace(res.headers.get('error-url'));
            }
            if (code === 404 || code === 500) {
                throw new ApiError({ code, message: code === 404 ? 'something.not.found' : 'something.went.wrong' });
            }
            if (noResponse) return {};
            if (returnJSON) return res.json();
            return res;
        })
        .then((response) => {
            if ((response.code && response.code > 399) || code > 399) throw new ApiError({ ...response, code });
            if (response.code === 401 && response.headers && response.headers.get('message') === 'SSO error occured') {
                window.location.replace(response.headers.get('error-url'));
            }
            return response;
        });
};

export { sendRequest, apiParams };
